import './SupplementPanel.scss'

import React from 'react'

import ListSupplementItem from './ListSupplementItem/ListSupplementItem'
import { getProductDetailsForListItem } from '../../../../../../../list-service'

const SupplementPanel = ({ product, item, isExpanded }) => {
  const { supplements, hasEducatorSupplements, hasStudentSupplements } = getProductDetailsForListItem(item)

  const isExpandedClass = isExpanded ? 'is-expanded' : ''
  const educatorSupplements = supplements.validEducatorSupplements
  const studentSupplements = supplements.validStudentSupplements

  return (
    <div className="supplement-panel">
      <div data-testid="supplement-panel-container" className={`supplement-panel__container ${isExpandedClass}`}>
        {hasEducatorSupplements && (
          <section data-testid="educator-supplements-section" className="supplement-panel__supplements-type">
            <h5 className="supplement-panel__supplements-title">Supplements for Educators Only</h5>
            <div className="supplement-panel__supplements">
              {educatorSupplements.map((supplement) => (
                <ListSupplementItem key={supplement.coreId} supplement={supplement} item={item} />
              ))}
            </div>
          </section>
        )}
        {hasStudentSupplements && (
          <section data-testid="student-supplements-section" className="supplement-panel__supplements-type">
            <h5 className="supplement-panel__supplements-title">Supplements for Students</h5>
            <div className="supplement-panel__supplements">
              {studentSupplements.map((supplement) => (
                <ListSupplementItem key={supplement.coreId} supplement={supplement} item={item} />
              ))}
            </div>
          </section>
        )}
      </div>
    </div>
  )
}

export default SupplementPanel
